import combineReducers from "redux/lib/combineReducers";

import notification from "./notification";

export default combineReducers({
  notification,
});
